import styled from "styled-components";
import {AppButton} from "./AppButton.jsx";
import {themeColor} from "../../theme";

export const AppButtonAuth = styled(AppButton)`
    background: ${themeColor("basicBlack")};
    border: 2px solid ${themeColor("basicBlack")};
    border-radius: 500px;
    padding: 13px 30px;
    height: 53px;
    width: 100%;
    align-self: stretch;
    font-family: var(--font-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 27px;
    text-transform: capitalize;
    color: ${themeColor("secondary")};
    transition: all 0.2s ease;

    &:hover {
        background: ${themeColor("primaryHover")};
        color: ${themeColor("secondary")};
    }
`;
